<script>
import NavBar from "@/components/NavBar";
import SideBarDigitalPrint from "@/components/SideBarDigitalPrint";
import FooterBar from "@/components/FooterBar";

export default {
  components: {
    NavBar,
    SideBarDigitalPrint,
    FooterBar
  }
}
</script>

<style scoped src="@/assets/css/inbox.css">

</style>
<style scoped src="@/assets/css/custom.css">
</style>

<template>
  <div >
    <nav-bar />

    <section class="main-content columns is-fullheight">
			
        <div class="column is-2 sidebar-container"  >
          <SideBarDigitalPrint />
        </div>

    
        <div class=" column is-10">
          <div class="section">
            <router-view/>
          
          
          </div>
        </div>
      
		</section>

    

    <footer-bar />

  </div>

</template>



